var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.wrapperClasses},[_c('DSTextElement',{attrs:{"color":_vm.textColor}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }